module.exports = {
    language: {
        name: 'English'
    },
    user: {
        name: '上海任威电子科技有限公司',
        nametext: '生产基地',
        home: '首页',
        company: '公司简介',
        team: '公司团队',
        culture: '企业文化',
        exhibition: '公司展示',
        partner: '合作伙伴',
        describe: '任威科技是一家专注于智能制造的综合性集团公司，集团下属5个子公司，拥有先进的贴装设备和检测设备，可贴装0201，BGA Pitch 0.35mm等精密Components，可以制造20层的PCBA；为用户提供高可靠性的产品和服务。',
        describe2: '公司成立于2009年4月，主要从事工业控制、汽车电子、医疗电子、物联网等产品OEM/ODM服务。公司坐落于上海市松江开发区，工厂总面积近5000平方米。',
        describetext: '公司描述',
        emplyee: '公司员工壹百伍拾余人，工程、质量及项目管理等主要部门负责人都曾在捷普、富士康、英华达、华硕等全球EMS工厂长期历练，工程经验丰富、质量管理及项目管理能力强。',
        emplyeetext: '拥有员工数量',
        salesvolume: '产品总销售额 ',
        salesvolumetext1: '2018年销售额达到:人民币3000万($4.3M)',
        salesvolumetext2: '2019年销售额达到: 人民币3500万($5.2M)',
        salesvolumetext3: '2020年销售额达到: 人民币4000万($6.2M)',
        salesvolumetext4: '2021年预计销售额达到: 人民币5000万($7.7M)',
        contact: '联系我们',
        address: '地址',
        addresstext: '上海市松江区昆港公路889号8幢',
        Postcode: '邮政编码',
        number: '电话号码',
        Fax: '传真',
        Email: '邮箱',
        business: '业务范围',
        Solutions: '案例：国巨下属pulse公司射频板（原美国公司）、伺服变频控制板，LED开关电源等',
        Products: '案例：冷敷机、米技恒温垫、大健康产品等',
        Manufacturing: 'SMT、DIP、测试、老化、组装等',
        Service: 'DFM、失效分析、实验测试服务等',
        Solutionstext: '方案',
        Productstext: '产品',
        Manufacturingtext: '制造',
        servicetext: '服务',
        news: '新闻',
        storage: '智能仓储',
        advantage: '我们的优势'
    },
    storage: {
        iqc: 'IQC智能电子看板',
        temperature: '仓库和车间恒温恒湿',
        e_kanban: '备料智能电子看板',
        intelligence_storage: '电子料智能仓库',
        workshop: '生产车间线边仓',
        goods_shelves: '无线智能货架',
        mes: 'MES追溯系统',
        pvs: 'PVS上料防错'
    },
    product: {
        molding: '注塑',
        purifier: '净化器',
        purifier2: '声控净化器',
        Videoconferencing: '视频会议',
        Payment: '支付终端',
        refrigerator: '车载冰箱',
        product1: '高铁座椅',
        product2: 'LED汽车仪表'
    },
    news: {
        detail: '详细信息 >',
        title1: '姜堰上海商会走访副会长单位上海任威电子科技有限公司',
        content1: '6月5日，姜堰上海商会顾问戴忠茂、会长周正明、书记黄宝生等一行走访副会长单位上海任威电子科技有限公司。',
        link1: 'https://mp.weixin.qq.com/s/30PhEs4YbvvEVryJ8Eq2CQ',
        title2: '上海市江苏商会青年联合会 “9月会长办公会暨走进上海任威电子”活动举办圆满成功',
        content2: '9月24日下午，上海市江苏商会青年联合会（以下简称“青联会”）在周常凤秘书长的的带领下，副会长代表、理事代表、会员代表及苏商商学院嘉宾十几人走访了上海任威电子科技有限公司（以下简称“上海任威电子”）。上海任威电子团队热情接待了青联会一行，双方进行了深入的交流。',
        link2: 'https://mp.weixin.qq.com/s/RZqh-NP2ciL9iYcqgHOx6w',
        title3: '同光走进明星学员企业—上海任威电子科技有限公司',
        content3: '精英齐聚，匠心筑梦，10月15日（周四），受EMBA28/PE18期纪武德纪总盛情邀请，组织同学们走进任威电子，学习企业的经营之道，加强同学人脉资源整合。',
        link3: 'https://mp.weixin.qq.com/s/_VF7qp2ETo9GjwC9_tM9vQ',
        title4: '走访调研民营企业上海任威电子科技有限公司',
        content4: '为贯彻落实习近平总书记在民营企业家座谈会上的重要讲话精神，了解掌握行业民营企业发展实际情况，帮助解决企业存在的困难和问题，推动民营经济在新形势下高质量发展。2020年6月24日上午，市中小企业发展服务中心信息化推进部、市计算机协会一行深入民营企业上海任威电子科技有限公司进行实地走访调研。',
        link4: 'https://mp.weixin.qq.com/s/aZEzkuNe5F1zHCl7MNL87w'
    },
    recruit: {
        recruit: '人才招聘',
        title1: '销售工程师',
        recruitinfo: '职位信息',
        info1: '1，负责国内（以华东为主）或国外地区的销售；',
        info2: '2，积极拓展新客户，维护客户关系；完成部门制定销售指标（公司给客户资源）；',
        info3: '3，推广公司产品，了解、挖掘客户需求；与技术团队沟通协调，获取以及完成成客户项目；',
        info4: '4，与公司财务、助理等团队配合，完成回款任务；',
        demand: '任职要求',
        info5: '1.全制大学大专及以上学历，电子工程，计算机，市场营销等相关专业',
        info6: '2. 基本的英语读写能力（国内客户可以不做严格限制）',
        info7: '3. 从事过相关研发、技术支持、测试等工作的优先，有工作经验的优先，应届毕业生也可以考虑',
        info8: '4. 出色的人际沟通与商务谈判能力',
        info9: '5. 喜欢具有挑战性的工作、有强烈团队合作精神',
        info10: '6. 有驾照的优先考虑',
        title2: '项目跟单工程师',
        info11: '1, 根据客户提供的图纸，就新产品进行报价（公司有报价模块）',
        info12: '2, 负责所有收到的客户产品的订单的管理归档，并转化为内部生产指令',
        info13: '3, 在项目运行中，保持与客户的积极有效的沟通，并及时将客户的要求传达到团队内；维持与客户的良好关系',
        info14: '4,制定项目的交付计划和关键节点，跟踪督促团队的工作进度，以满足客户的需求计划',
        info15: '5,对于收到的客户投诉，组织团队分析原因，制定纠正预防措施并及时反馈给客户。对于售后产生的质量损失，进行统计以便后续分析',
        info16: '6, 制定开票计划，并协助财务部对已发货产品开票及收款',
        info17: '1.全制大学大专及以上学历，电子类相关专业',
        info18: '2. 电子或相关制造行业 1 年以上项目管理经验，有接待客户的能力优先',
        info19: '3. 具备良好的沟通能力、谈判能力和成本控制意识',
        info20: '4. 熟练操作办公软件',
        info21: '5. 有良好的职业道德，敬业精神和团队合作精神',
        treatment: '待遇条件',
        condition1: '1，基本工资+岗位工资+绩效工资+租房补贴+全勤奖+工作年金',
        condition2: '2，全年 13 薪，每年 1-2 次国内或国外旅游',
        condition3: '3，各个节日的福利，生日金，年假，加班补助及加班调休等',
        condition4: '4，工作满 5 年、10 年有股权分红',
        condition5: '5，公司不定期的安排厂内和外派培训等',
        condition6: '6，项目跟单工程师有项目补助，销售工程师有销售提成',
        contact: '联系方式：18917388687（微信同），联系人：纪先生，联系地址：上海市松江区昆港公路889号8幢'
    },
    team: {
        engineering: '工程部',
        project: '项目部',
        qaqc: '质量部',
        production: '生产部',
        engineeringtext: '拟定产品的制造作业流程拟定有关原物料之BOM List及料号编码作业',
        projecttext: '新电子产品开发、生产、工艺制定以及电子产品的初步评估和经济效益评估。客户跟踪服务. ',
        qaqctext: '组织IQC、PQC、QA以及测试员、组长按要求对产品进行检查，以确保只有合格的产品才能提交给客户。 ',
        productiontext: '据公司的生产计划，掌握生产进度，搞好各车间的协调，组织分配劳动力，平衡调度设备材料。'
    },
    exhibition: {
        work: '办公环境',
        SMT1: 'SMT一工厂展示',
        SMT2: 'SMT二工厂展示'
    },
    culture: {
        title: '定义我们企业文化的价值观是',
        culture1: '遵纪守法',
        culture2: '诚实守信',
        culture3: '客户至上',
        culture4: '艰苦奋斗',
        culture5: '用于创新',
        culture6: '面向未来',
        foo: '我们的能量源于每位员工的观点、能力，经验和奉献。'
    },
    market: {
        manufacturer: '制造商：',
        type: '类型：',
        classify: '分类：',
        message: '请先删除分类',
        languageType: '1',
        search: '搜索',
        placeholder: '请输入产品名',
        name: '产品名',
        image: '产品图片',
        model: '产品型号',
        manufacturer1: '产品制造商',
        costPrice: '成本价',
        specialPrice: '优惠价',
        sellingPrice: '售价',
        description: '描述',
        commodity: '芯片销售',
        shopping: '加入购物车',
        successfully: '成功加入购物车！',
        handle: '操作',
        inquiry: '商品询价',
        products: '您好：我想咨询一下以下产品的价格',

        mailbox: '电子邮箱：',
        phone: '手机号码：',
        hrefShopping: '产品型号：',
        cancel: '取 消',
        confirm: '确 定',
        subject: '芯片询价',
        enquiry: '询价',
        mailboxformat: '邮箱号格式不正确',
        mailboxs: '请输入邮箱号',
        phoneformat: '手机号格式不正确',
        phones: '请输入手机号',
        send0: '发送成功!',
        send1: '发送失败，请按照格式正确填写！！！',
        verification: '验证码：',
        verificationtrue: '请输入正确的验证码！',
        // verificationtrue1:'验证码不能为空！'
    },
    honor: {
        zhengshu7: "zhengshu092601.png",
        zhengshu9: "zhengshu092604.png",
        zhengshu11: "zhengshu092605.png",
    }
}


// WEBPACK FOOTER //
// ./src/components/language/zh.js